import { render, staticRenderFns } from "./filter-container.vue?vue&type=template&id=2c5d24cb&"
import script from "./filter-container.vue?vue&type=script&lang=js&"
export * from "./filter-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/filter-container/filter-container.vue
// module id = 77
// module chunks = 0